import { useState } from 'react';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import {
  SearchFieldGroupStyle,
  SearchControlsRowStyle,
  SearchIconWrapperStyle,
  SearchInputStyle,
  SearchInputWrapperStyle,
  SearchLabelStyle,
  SearchSectionStyle,
} from '../ContractIdSelectionModal.style';
import { SelectionSummary } from './SelectionSummary';

const MIN_QUERY_LENGTH = 3;

interface SearchSectionProps {
  onSearch: (query: string) => void;
  selectedCount: number;
  totalContractCount: number;
  selectedTaxIdCount: number;
  remainingTaxIds: number;
  taxIdLimit: number;
}

export function SearchSection({
  onSearch,
  selectedCount,
  totalContractCount,
  selectedTaxIdCount,
  remainingTaxIds,
  taxIdLimit,
}: SearchSectionProps) {
  const [query, setQuery] = useState('');

  return (
    <SearchSectionStyle aria-label="Contract ID search">
      <SearchLabelStyle htmlFor="contractIdSearchInput">Search Contract ID(s)</SearchLabelStyle>
      <SearchControlsRowStyle>
        <SearchFieldGroupStyle>
          <SearchInputWrapperStyle>
            {!query && (
              <SearchIconWrapperStyle data-testid="contract-id-search-icon">
                <IconSymbol icon="search" size={24} color="#4B4D4F" />
              </SearchIconWrapperStyle>
            )}
            <SearchInputStyle
              id="contractIdSearchInput"
              type="search"
              placeholder="Search Contract ID"
              aria-label="Contract ID search"
              aria-describedby="searchHelp"
              value={query}
              onChange={(event) => {
                const value = event.target.value;
                setQuery(value);
                onSearch(value);
              }}
            />
          </SearchInputWrapperStyle>
        </SearchFieldGroupStyle>
        <SelectionSummary
          selectedCount={selectedCount}
          totalContractCount={totalContractCount}
          selectedTaxIdCount={selectedTaxIdCount}
          remainingTaxIds={remainingTaxIds}
          taxIdLimit={taxIdLimit}
        />
      </SearchControlsRowStyle>
      <span id="searchHelp" hidden>
        Enter at least 3 characters to search.
      </span>

    </SearchSectionStyle>
  );
}
